import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { isUuid, rootRoute } from "../../platform/routes";
import { requireSession } from "../../platform/session";
import { ConsentScreen } from "./ConsentScreen";
import { ProblemScreen } from "./ProblemScreen";

// A `request` that is not a request's id is dropped, and the page says the request has ended.
const consentSearch = z.object({
  request: z.string().refine(isUuid).optional().catch(undefined),
});

/**
 * Where `/api/oauth/authorize` sends the browser with a request it proved (spec platform/mcp-oauth,
 * PR 4). Signed out, the person signs in and comes back here; the card stands alone, as sign-in's,
 * outside the app's frame, since no team is the page's.
 */
export const oauthConsentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "oauth/consent",
  validateSearch: (search) => consentSearch.parse(search),
  beforeLoad: async ({ context, location }) => {
    await requireSession(context.queryClient, location);
  },
  component: ConsentScreen,
});

const problemSearch = z.object({ reason: z.string().optional().catch(undefined) });

/** Where it sends the browser when it cannot prove the app or its way back (decision 22). */
export const oauthProblemRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "oauth/problem",
  staticData: { public: true },
  validateSearch: (search) => problemSearch.parse(search),
  component: ProblemScreen,
});
